import { useQuery } from "@tanstack/react-query";
import { fetchSignupConfig } from "@/api/billing";
import { queryKeys } from "@/lib/query-keys";

/**
 * Reads whether the current user may create a new self-serve organization.
 * The shared cache key is fresh for five minutes; stale-query refetch triggers
 * remain enabled, but failed requests are never retried automatically. Errors
 * stay on the query result so routing can fail closed, while existing
 * organizations continue to use their persisted enrollment marker.
 *
 * @returns The React Query result for the server-authoritative signup config.
 */
export const useSignupConfig = () => {
  return useQuery({
    queryKey: queryKeys.billing.signupConfig(),
    queryFn: fetchSignupConfig,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
